export const SUBMIT_XHR_MAX_BODY = 250000;

function utf8LengthAtMost(str) {
  return typeof TextEncoder === 'function' ? new TextEncoder().encode(str).length : str.length * 3;
}

export function estimatedEnvelopeLength(data) {
  const { sdk, bb, ...rest } = data;
  const plainBytes = (sdk ? sdk.length : 0) + (bb ? bb.length : 0) + utf8LengthAtMost(JSON.stringify(rest)) + 32;
  return Math.ceil((plainBytes + 16) / 3) * 4 + 64;
}

export function shouldSplitSubmit(data, maxBody) {
  return !!data.sdk && !!data.bb && estimatedEnvelopeLength(data) > maxBody;
}
